import createSagaMiddleware from 'redux-saga';
import { createListenerMiddleware } from '@reduxjs/toolkit';

export { default as thunkMiddleware } from 'redux-thunk';
export const sagaMiddleware = createSagaMiddleware();
export const listenerMiddleware = createListenerMiddleware();
